import { Component, Input } from '@angular/core';
import { Placement } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sume-help-tooltip',
    templateUrl: './help-tooltip.component.html',
    styleUrls: ['./help-tooltip.component.scss'],
})
export class HelpTooltipComponent {
    @Input() placement: Placement = 'top';
    @Input() message: string = '';
    @Input() size: 'small' | 'default' = 'default';
}
